import { gql } from '@apollo/client';

export const PATCH_COMPONENTS_LIST = gql`
    mutation patchComponentList( $input: PatchComponentListInput! ) {
        result: patchComponentList( input: $input ) {
            componentListId
            type
            uuids
        }
    }
`;